module.exports = __webpack_public_path__ + "static/homepage-img-placeholder-b75f3c94f9572be39eb003f1785efbb9.png";